import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { Row, Col, Container } from 'reactstrap';
import InfiniteScroll from 'react-infinite-scroller';
import areIntlLocalesSupported from 'intl-locales-supported';

import * as generalActions from 'modules/general/action';
import * as reportesAction from '../action';
import ReporteRow from './reporteRow';

let DateTimeFormat;
if (areIntlLocalesSupported(['es', 'es-AR'])) {
  DateTimeFormat = global.Intl.DateTimeFormat;
} else {
  const IntlPolyfill = require('intl');
  DateTimeFormat = IntlPolyfill.DateTimeFormat;
  require('intl/locale-data/jsonp/es');
  require('intl/locale-data/jsonp/es-AR');
}

const fechaFormat = {
  month: 'long',
  year: 'numeric',
};

@connect(store => ({
  reportes: store.getIn(['reportes', 'lista']),
  scrollControl: store.getIn(['reportes', 'scrollControl']),
  loading: store.getIn(['general', 'loadingbar', 'show']),
}))
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = { filtroReporte: false, mensual: true, fechaSeleccionada: new Date() };
  }
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('REPORTES'));
    this.props.reportes.size === 0 && this.filtrar();
  };
  filtrar = () => {
    const { scrollControl } = this.props;
    const { filtroReporte, fechaSeleccionada, mensual } = this.state;
    this.props.dispatch(reportesAction.getReportes(filtroReporte, moment(fechaSeleccionada).toISOString(), mensual, scrollControl.get('page') * 50));
  };
  componentDidUpdate = (prevProps, prevState) => {
    const { dispatch } = this.props;
    const { fechaSeleccionada, mensual, filtroReporte } = this.state;
    if ((fechaSeleccionada && !moment(fechaSeleccionada).isSame(moment(prevState.fechaSeleccionada))) || mensual != prevState.mensual || filtroReporte != prevState.filtroReporte) {
      dispatch(reportesAction.clear('all'));
    }
  };
  componentWillUnmount = () => {
    this.props.dispatch(reportesAction.clear('lista'));
  };
  solucionarCorrectas = () => {
    const { reportes, dispatch } = this.props;
    let reportesIds = [];
    reportes.map(reporte => {
      if ((reporte && reporte.get('viajo') && reporte.getIn(['_reserva', 'concretada'])) || (!reporte.get('viajo') && reporte.getIn(['_reserva', 'cancelada']))) reportesIds.push(reporte.get('id'));
    });
    if (reportesIds.length > 0) return dispatch(reportesAction.solucionarCorrecto(reportesIds));
    alert('No hay reportes correctos.');
  };
  disableDates = date => moment(date).isAfter(moment());
  render() {
    const { reportes, loading, dispatch, scrollControl } = this.props;
    const { filtroReporte, mensual, fechaSeleccionada } = this.state;

    return (
      <Container fluid>
        <Row className="mb-20">
          <Col md="12">
            <MaterialUI.Paper zDepth={2}>
              <Row className="p-lr-10">
                <Col md="2" sm="3" className="ml-10">
                  <MaterialUI.SelectField
                    underlineStyle={{ display: 'none' }}
                    autoWidth={true}
                    floatingLabelFixed
                    floatingLabelText="Reportes"
                    onChange={(e, val, filtroReporte) => this.setState({ filtroReporte })}
                    value={filtroReporte}
                  >
                    <MaterialUI.MenuItem value={null} primaryText="Todos" />
                    <MaterialUI.MenuItem value={true} primaryText="Solucionados" />
                    <MaterialUI.MenuItem value={false} primaryText="Sin solucionar" />
                  </MaterialUI.SelectField>
                </Col>
                <Col md="2" sm="4">
                  <MaterialUI.DatePicker
                    autoOk
                    onDismiss={() => false}
                    DateTimeFormat={DateTimeFormat}
                    underlineStyle={{ display: 'none' }}
                    cancelLabel="Cancelar"
                    formatDate={new DateTimeFormat('es-AR', Object.assign(mensual ? {} : { day: 'numeric' }, fechaFormat)).format}
                    locale="es-AR"
                    onChange={(dummy, fechaSeleccionada) => this.setState({ fechaSeleccionada })}
                    value={fechaSeleccionada}
                    floatingLabelText="Fecha Seleccionada"
                    hintText="Fecha"
                    container="inline"
                    mode="landscape"
                    shouldDisableDate={this.disableDates}
                  />
                </Col>
                <Col md="2" className="pt-30">
                  <MaterialUI.Checkbox label="Mensual" checked={mensual} onCheck={(e, mensual) => this.setState({ mensual })} />
                </Col>
                <Col md="1" sm="3" xs="2" className="pt-25">
                  <MaterialUI.RaisedButton primary label="Filtrar" disabled={loading || !scrollControl.get('hasMore')} onTouchTap={() => this.filtrar(0)} />
                </Col>
                <Col lg="4" md="5" sm="6" xs="9" className="pt-25 ml-30">
                  <MaterialUI.RaisedButton primary label="Solucionar correctos" className="mb-20" disabled={loading || reportes.size === 0} onTouchTap={this.solucionarCorrectas} />
                </Col>
              </Row>
            </MaterialUI.Paper>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <MaterialUI.Paper zDepth={2}>
              <MaterialUI.List className="noPadding">
                <InfiniteScroll pageStart={0} threshold={1} initialLoad={false} loadMore={scrollControl.get('hasMore') ? this.filtrar : () => false} hasMore={!loading && scrollControl.get('hasMore')}>
                  {reportes.map(reporte => (
                    <ReporteRow key={reporte.get('id')} reporte={reporte} dispatch={dispatch} />
                  ))}
                </InfiniteScroll>
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
        </Row>
      </Container>
    );
  }
}

const updateTime = () => moment();



// WEBPACK FOOTER //
// src/modules/reportes/components/lista.js